console.log("%c{mea \ncoda}", "background:#000;height:60px;padding:10px;font-size:15px;color:#fff", "");
//settings
var APP;
var imgRoot = "assets/images/";
var sndRoot = "assets/sounds/";
var fntRoot = "assets/fonts/";
var gameLogoPath = "loadingimg/gameLogo.png";
var loadingBG_color = 0x000000;
var loadingLogo1_color = 0x111111;
var loadingLogo2_color = 0xffffff;
var fontsPercentage = 10;
var soundsPercentage = 50;
var imagesPercentage = 40;

var onLoadingComplete = function () {
  transition.fade(gameScreen, 1);
  setTimeout(loadingScreen.delete, 2000);
  setTimeout(gameScreen.showBgGlow, 1500);
  ads.gameplayStart();
};

var images = [
  {
    path: "atlas.json",
  },
  {
    path: "glow.svg",
  },
  //    {
  //        path: "crazy-logo.png"
  //	},
];
var sounds = [
  {
    path: "shake.mp3",
    name: "shake",
    volume: 1,
    loop: false,
  },
  {
    path: "win.mp3",
    name: "win",
    volume: 1,
    loop: false,
  },
  {
    path: "scoreCount.mp3",
    name: "scoreCount",
    volume: 0.1,
    loop: false,
  },
  {
    path: "selectGem.mp3",
    name: "selectGem",
    volume: 0.2,
    loop: false,
  },
  {
    path: "btnClick.mp3",
    name: "btnClick",
    volume: 1,
    loop: false,
  },
];
for (var i = 0; i < 16; i++) {
  sounds.push({
    path: "explode" + (i + 1) + ".mp3",
    name: "match" + (i + 1),
    volume: 0.2,
    loop: false,
  });
}
var fonts = [
  {
    path: "manrope-bold.otf",
    name: "manrope-bold",
  },
  {
    path: "manrope-medium.otf",
    name: "manrope-medium",
  },
];

var loadingScreen = {};
var loadingBG_sprite, screen_container, loadingProgress, lastProgress, loading_container, loadingBar_sprite, loadingBarFrame_sprite, loadingLogo1_sprite, loadingLogo2_sprite;
var loadingCompleted = false;

// MODERNIZER CHECK FOR WEBSOCKET AND CANVAS SUPPORT ********* ********* ********* *********
//if (!window.WebSocket) {
//    console.log("This game is not optimized for this browser. Please install Google Chrome.");
//
//}

function isCanvasSupported() {
  var elem = document.createElement("canvas");
  return !!(elem.getContext && elem.getContext("2d"));
}

if (!isCanvasSupported()) {
  console.log("This game is not optimized for this browser. Please install Google Chrome.");
  // SAMO PRIKAZATI POPUP
}

// DPI SETTINGS ********* ********* ********* *********
var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var dpr = Number(window.devicePixelRatio);
//
// GENERATE CANVAS GAME **************************************
if (gameLogoPath) {
  PIXI.loader.add(gameLogoPath);
  PIXI.loader.once("complete", generateCanvas);
  PIXI.loader.load();
} else {
  setTimeout(generateCanvas, 10);
}
//generateCanvas();

function generateCanvas() {
  // SETUP CANVAS
  PIXI.loader.reset();
  PIXI.settings.SCALE_MODE = PIXI.SCALE_MODES.LINEAR;
  APP = new PIXI.Application(window.innerWidth, window.innerHeight, {
    resolution: dpr,
    transparent: false,
    autoResize: true,
    legacy: true,
    clearBeforeRender: true,
    backgroundColor: 0x000000,
    antialias: true,
    forceCanvas: false,
  });
  APP.renderer.plugins.interaction.moveWhenInside = true;
  $("#game").append(APP.view);

  if (APP.renderer instanceof PIXI.CanvasRenderer) {
    gameLogoPath = "";
  } else {
  }

  setRatioScale();
  screen_container = new Container(APP.stage);
  loadingScreen.root = new Container(screen_container);
  transition.setScreen(loadingScreen);
  loadAssets(images, sounds, fonts);
}

function loadAssets(images, sounds, fonts) {
  ads.gameLoadingStart();
  loadingProgress = 0;
  lastProgress = 0;

  loadingScreen.draw();
  resize();

  //images
  if (images.length > 0) {
    for (var i = 0; i < images.length; i++) {
      PIXI.loader.add(imgRoot + images[i].path);
    }
    PIXI.loader.on("progress", onImageLoadProgress);
    PIXI.loader.load();
  } else {
    loadingProgress += imagesPercentage;
    onLoadProgress();
  }

  //sounds
  if (sounds.length > 0) {
    for (var i = 0; i < sounds.length; i++) {
      allSounds[sounds[i].name] = new Howl({
        src: sndRoot + sounds[i].path,
        loop: sounds[i].loop || false,
      });
      allSounds[sounds[i].name].volume(sounds[i].volume || 1);
      allSounds[sounds[i].name].on("load", onSoundLoaded);
    }
  } else {
    loadingProgress += soundsPercentage;
    onLoadProgress();
  }

  //fonts
  if (fonts.length > 0) {
    //var fontLoader = new type.Loader();
    for (var i = 0; i < fonts.length; i++) {
      //fontLoader.add(fonts[i].name, fntRoot + fonts[i].path);
      var fontLoader = new FontFaceObserver(fonts[i].name);
      fontLoader.load().then(onFontsLoaded);
    }
    //fontLoader.once('loadComplete', onFontsLoaded);
    //fontLoader.load();
  } else {
    loadingProgress += fontsPercentage;
    onLoadProgress();
  }
}

loadingScreen.draw = function () {
  //bg
  loadingBG_sprite = new WhiteRectangle(loadingScreen.root, [APP.screen.width, APP.screen.height], loadingBG_color);
  loadingBG_sprite.anchor.set(0);

  loadingScreen.dust = new Dust(loadingScreen.root, 1, 20, [0xffffff, 0xffff00, 0xff00ff, 0x00ffff], 1);
  loadingScreen.dust.alpha = 1;

  loadingScreen.circle = new Circle(loadingScreen.root, Math.min(APP.screen.width, APP.screen.height) / 4);
  loadingScreen.circle.tint = loadingBG_color;

  loading_container = new Container(loadingScreen.root);
  loading_container.y = 0;
  loading_container.tween = TweenMax.to(loading_container, 1, {
    pixi: {
      y: 0,
    },
    ease: Power1.easeInOut,
    repeat: -1,
    yoyo: true,
  });

  loadingScreen.playContainer = new Container(loadingScreen.root);

  //progress bar
  if (!gameLogoPath) {
    loadingScreen.circle.visible = false;
    loadingBarFrame_sprite = new Rectangle(loading_container, [500, 20], [4, 0xffffff, 1], [0x000000, 0]);
    loadingBarFrame_sprite.tint = loadingLogo2_color;

    loadingBar_sprite = new WhiteRectangle(loading_container, [loadingBarFrame_sprite.width / 100, loadingBarFrame_sprite.height], loadingLogo2_color);
    loadingBar_sprite.anchor.set(0, 0.5);
  }

  //game logo
  else {
    loadingLogo1_sprite = new Sprite(loading_container, gameLogoPath);
    loadingLogo1_sprite.tint = loadingLogo1_color;
    loadingLogo1_sprite.position.set(APP.screen.width * 0.5, APP.screen.height * 0.33);

    loadingLogo2_sprite = new Sprite(loading_container, gameLogoPath);
    loadingLogo2_sprite.tint = loadingLogo2_color;
    loadingLogo2_sprite.position.set(APP.screen.width * 0.5, APP.screen.height * 0.33);

    loadingBar_sprite = new WhiteRectangle(loading_container, [loadingLogo1_sprite.width / 100, loadingLogo1_sprite.height]);
    loadingBar_sprite.anchor.set(0);
    loadingBar_sprite.position.set(loadingLogo1_sprite.x - loadingLogo1_sprite.width * 0.5, loadingLogo1_sprite.y - loadingLogo1_sprite.height * 0.5);

    loadingLogo2_sprite.mask = loadingBar_sprite;
  }
  loadingScreen.isDrawn = true;

  loadingScreen.resize();
};

function updateProgressBar(duration) {
  if (!gameLogoPath) {
    TweenMax.to(loadingBar_sprite, duration || 0.3, {
      pixi: {
        width: (loadingBarFrame_sprite.width * loadingProgress) / 100,
      },
      ease: Power1.easeOut,
    });
  } else {
    TweenMax.to(loadingBar_sprite, duration || 0.3, {
      pixi: {
        width: (loadingLogo2_sprite.width * loadingProgress) / 100,
      },
      ease: Power1.easeOut,
    });
  }
}

function removeProgressBar() {
  if (!gameLogoPath) {
    loadingBarFrame_sprite.visible = false;
    TweenMax.to(loadingBar_sprite, 0.5, {
      pixi: {
        height: 0,
      },
      ease: Power1.easeIn,
      onComplete: function () {
        onLoadingComplete();
        setTimeout(function () {
          loading_container.tween.kill();
        }, 500);
      },
    });
  } else {
    TweenMax.to(loadingLogo1_sprite, 0.5, {
      pixi: {
        alpha: 0,
      },
    });
    TweenMax.to(loadingScreen.circle, 0.5, {
      pixi: {
        alpha: 0,
      },
      delay: 1,
    });
    loadingLogo2_sprite.mask.visible = false;
    loadingLogo2_sprite.mask.visible = false;
    loadingLogo2_sprite.mask = null;
    TweenMax.to(loadingLogo2_sprite, 1, {
      pixi: {
        alpha: 0,
      },
      delay: 2,
      onComplete: function () {
        setTimeout(function () {
          loading_container.tween.kill();
        }, 500);
        if (!ads.showAdOnLoad) {
          onLoadingComplete();
        } else {
          loadingScreen.playBtn = new Button(
            loadingScreen.playContainer,
            "",
            "play.png",
            function () {
              setTimeout(onLoadingComplete, 1000);
              loadingScreen.playBtn.interactive = false;
              ads.showAd();
              TweenMax.to(loadingScreen.playBtn, 0.5, {
                pixi: {
                  scale: 0.5,
                  alpha: 0,
                },
                ease: Back.easeIn,
              });
            },
            LOADING_BUTTON
          );
          loadingScreen.playBtn.img.setTransform(15, 0);
          loadingScreen.playBtn.scale.set(0.5);
          loadingScreen.playBtn.alpha = 0;
          TweenMax.to(loadingScreen.playBtn, 0.5, {
            pixi: {
              scale: 1,
              alpha: 1,
            },
            ease: Back.easeOut,
          });
        }
      },
    });
  }
}

loadingScreen.resize = function () {
  if (!loadingScreen.isDrawn) {
    return;
  }
  if (!loadingScreen.root.visible) {
    return;
  }

  //bg
  loadingBG_sprite.width = APP.screen.width;
  loadingBG_sprite.height = APP.screen.height;

  loadingScreen.circle.width = Math.min(APP.screen.width, APP.screen.height) / 2;
  loadingScreen.circle.height = Math.min(APP.screen.width, APP.screen.height) / 2;
  loadingScreen.circle.setTransform(APP.screen.width / 2, APP.screen.height / 2);

  loadingScreen.playContainer.setTransform(APP.screen.width / 2, APP.screen.height / 2, ratio_scale, ratio_scale);

  //progress bar
  if (!gameLogoPath) {
    loadingBarFrame_sprite.scale.set(ratio_scale);
    loadingBarFrame_sprite.position.set(APP.screen.width * 0.5, APP.screen.height * 0.5);

    loadingBar_sprite.height = loadingBarFrame_sprite.height;
    loadingBar_sprite.position.set(loadingBarFrame_sprite.x - loadingBarFrame_sprite.width * 0.5, loadingBarFrame_sprite.y);
    updateProgressBar(0.01);
  }
  //game logo
  else {
    var scaleW = Math.min(0.5, (APP.screen.height * 0.5) / APP.screen.width);
    if (APP.screen.width < APP.screen.height) {
      scaleW = 0.75;
    }

    //        loadingLogo1_sprite.height *= (APP.screen.width * scaleW / loadingLogo1_sprite.width);
    //        loadingLogo1_sprite.width = APP.screen.width * scaleW;
    //        loadingLogo1_sprite.position.set(APP.screen.width * 0.5, APP.screen.height * 0.5);
    loadingLogo1_sprite.setTransform(APP.screen.width * 0.5, APP.screen.height * 0.5, ratio_scale, ratio_scale);

    loadingLogo2_sprite.height = loadingLogo1_sprite.height;
    loadingLogo2_sprite.width = loadingLogo1_sprite.width;
    loadingLogo2_sprite.position.set(loadingLogo1_sprite.x, loadingLogo1_sprite.y);

    loadingBar_sprite.height = loadingLogo1_sprite.height;
    loadingBar_sprite.width = loadingLogo1_sprite.width;
    loadingBar_sprite.position.set(loadingLogo1_sprite.x - loadingLogo1_sprite.width * 0.5, loadingLogo1_sprite.y - loadingLogo1_sprite.height * 0.5);
    updateProgressBar(0.01);

    //loadingLogo1_sprite.height *= 0.995;
    //loadingLogo1_sprite.width *= 0.995;

    //        //center
    //        var totalHeight = (loadingBarFrame_sprite.y - loadingBarFrame_sprite.height * 0.5) - (loadingLogo_sprite.y - loadingLogo_sprite.height * 0.5);
    //        var diff = (loadingBarFrame_sprite.y - loadingBarFrame_sprite.height * 0.5) - (APP.screen.height * 0.5 + totalHeight * 0.5);
    //        loadingBarFrame_sprite.y -= diff;
    //        loadingBar_sprite.y -= diff;
    //        loadingLogo_sprite.y -= diff;
  }
};

resize_methods.push(loadingScreen.resize);

//delete
loadingScreen.delete = function () {
  loadingScreen.root.delete();
  loadingScreen.isDrawn = false;
};

function onLoadProgress() {
  if (loadingCompleted) return;

  updateProgressBar();

  ads.gameLoadingProgress(loadingProgress / 100);

  if (loadingProgress >= 99.99) {
    ads.gameLoadingFinished();
    loadingCompleted = true;
    setTimeout(function () {
      startGame();
      removeProgressBar();
    }, 250);
  }
}

function onImageLoadProgress(loader, resource) {
  loadingProgress += (imagesPercentage * (loader.progress - lastProgress)) / 100;
  lastProgress = loader.progress;
  onLoadProgress();
}

function onFontsLoaded() {
  loadingProgress += fontsPercentage;
  onLoadProgress();
}

function onSoundLoaded() {
  loadingProgress += soundsPercentage / sounds.length;
  onLoadProgress();
}
